<template>
  <div class="tuolele-main-box set-combo">
    <el-row type="flex" justify="start" class="tuolele-main-search">
      <el-button type="success" @click="popImprove()">新增活动用户</el-button>
      <el-button type="info" @click="downloadTemp()">下载模版</el-button>
      
      <el-upload
        class="upload-demo"
        action="string"
        style="margin-left: 20px;"
        :with-credentials="true"
        :show-file-list="false"
        :headers="{ 'Content-Type': 'multipart/form-data' }"
        :http-request="uploadFile"
        accept=".xls"
        name="file"
      >
        <el-button slot="trigger" type="primary">导入Excel表</el-button>
        
      </el-upload>
     
      <!-- <el-button type="info" @click="fnExportExcel()">导出Excel</el-button> -->
    </el-row>
    <div class="tuolele-main-content">
      <el-table ref="student_record" :data="studentLists" border>
        <el-table-column prop="user_key" label="用户标识" />
        <el-table-column prop="cs" label="抽奖次数" />
        <el-table-column label="操作" width="210">
          <template slot-scope="scope">
            <el-button type="success" size="mini" @click="popImprove(scope.row)">编辑</el-button>
            <!-- <el-button type="danger" size="mini" @click="fnDelete(scope.row.id)">删除</el-button> -->
          </template>
        </el-table-column>
      </el-table>
      <div class="footer pagination-footer">
        <div class="block">
          <el-pagination
            layout="prev, pager, next, slot, jumper"
            :current-page.sync="listQuery.p"
            prev-text="上一页"
            next-text="下一页"
            :total="listQuery.total"
            :page-size="listQuery.limit"
            @current-change="fnGetLists"
          />
        </div>
      </div>

    </div>

    <el-dialog :key="'create'+improveKey" title="新增/编辑学生" :visible.sync="dialogImprove" width="600px">
      <el-form ref="postForm" :model="postForm" :rules="rules">
        <el-form-item label="用户标识" prop="user_key">
          <el-input v-model="postForm.user_key" style="width: 400px;" placeholder="请输入内容" />
        </el-form-item>
        <el-form-item label="抽奖次数" prop="cs">
          <el-input-number v-model="postForm.cs" :min="1" :max="100" label="描述文字" />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="fnSubmit">确定</el-button>
      </span>
    </el-dialog>
    <!-- <el-dialog v-if="dialogExchange" title="转换课时包" :visible.sync="dialogExchange" width="600px">
      <active-exchange-course :key="improveKey" :relation-id="relationId" @successCBK="fnGetLists()" />
    </el-dialog> -->
  </div>
</template>
<script>

import Tool from '@/assets/js/tool.js'
import { validateRequire } from '@/utils/validate'

const defaultPostForm = {
  id: '',
  lottery_id: '',
  user_key: '',
  cs: ''
}

import jquery from 'jquery'

export default {
  name: 'StoreSetting',
  components: {

  },
  data() {
    return {
      dialogImprove: false,
      dialogExchange: false,
      postForm: Object.assign({}, defaultPostForm),
      improveKey: 999,
      relationId: '',
      listQuery: {
        total: 0,
        p: 1,
        limit: 20,
        lottery_id: ''
      },
      studentLists: [],
      rules: {
        user_key: [{ validator: validateRequire, trigger: 'manual', message: '用户标识' }],
        cs: [{ validator: validateRequire, trigger: 'manual', message: '抽奖次数' }]
      }
    }
  },
  created() {
    this.listQuery.lottery_id = this.$route.query.id
    this.postForm.lottery_id = this.$route.query.id
  },
  mounted() {
    this.fnGetLists()
  },
  methods: {
    fnGetLists() {
      this.dialogImprove = false
      this.dialogExchange = false
      this.$http.getLuckyActiveUserList(this.listQuery).then(res => {
        this.studentLists = res.data.list
        this.listQuery.total = parseInt(res.data.count || 0)
      })
    },
    fnExportExcel() {
      Tool.exportExcelElTable('活动学生', this.$refs['student_record'])
    },
    popImprove(user) {
      if (!user) {
        this.postForm.id = ''
        this.postForm.cs = 1
        this.postForm.user_key = ''
      } else {
        this.postForm.id = user.id
        this.postForm.cs = user.cs
        this.postForm.user_key = user.user_key
      }
      this.improveKey++
      this.dialogImprove = true
    },
    downloadTemp() {
      location.href = "https://late-care.tuolele.cn/%E6%89%B9%E9%87%8F%E6%8A%BD%E5%A5%96%E6%B4%BB%E5%8A%A8%E7%94%A8%E6%88%B7%E4%B8%8A%E4%BC%A0%E6%A8%A1%E6%9D%BF.xls"
    },
    fnSubmit() {
      this.$refs.postForm.validate(valid => {
        if (valid) {
          this.$http.improveLuckyUser(this.postForm).then(res => {
            if (res.code == 200) {
              this.$message({
                type: 'success',
                message: '操作成功'
              })
              this.dialogImprove = false
              this.fnGetLists()
            }
          })
        }
      })
    },
    uploadFile(params) {
      const file = params.file
      const self = this
      const formData = new FormData()
      formData.append('file', file)
      formData.append('lottery_id', this.listQuery.lottery_id)
      jquery.ajax({
        // url: 'http://172.16.0.75:8867/cms.php/Excelupload/uploadLotteryUser',
        url: 'https://third.tuolele.cn/cms.php/Excelupload/uploadLotteryUser',
        type: 'post',
        data: formData,
        contentType: false,
        processData: false,
        xhrFields: {
          withCredentials: true
        },
        crossDomain: true,
        success: function(res) {
          if (res.code == 200) {
            self.$message({
              type: 'success',
              message: '导入成功！'
            })
          } else if (res.code == 540 && res.data) {
            self.errorList = res.data
            self.dialogVisible = true
          } else if (res.code == 550) {
            self.$message({
              type: 'info',
              message: res.desc
            })
          }
        }
      })
    },
    fnDelete(id) {
      this.$confirm('是否删除该报名学员?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http.removeJoinSub({ id }).then(() => {
          this.$message({
            type: 'success',
            message: '删除成功'
          })
          this.fnGetLists()
        })
      })
    },
    fnToDetail() {

    }

  }
}
</script>
<style lang="scss">
  .wq_flex {
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
}

.wq_flex_wrap {
  flex-wrap: wrap;
}

.wq_flex_sub {
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  flex: 1;
}

.set-combo {
  .self-table {
    margin-top: 0 !important;
  }
  .el-form-item__label {
    font-size: 16px;
    color: #333;
  }
  .el-form-item__content {
    margin: 0 20px 0 12px;
  }
  .el-button.el-button-confirm {
    width: 80px !important;
  }
}
</style>
